import React, { useContext, useMemo, useState } from 'react';
import { IUser } from '../models/auth';

export const UserContext = React.createContext<IUser | null | undefined>(undefined);
export const UserUpdateContext = React.createContext<((user: IUser | null) => void) | undefined>(
  undefined
);

export function useUser(): IUser | null {
  const user = useContext(UserContext);
  if (user === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return user;
}

export function useUpdateUser(): (user: IUser | null) => void {
  const setUser = useContext(UserUpdateContext);
  if (setUser === undefined) {
    throw new Error('useUpdateUser must be used within a UserProvider');
  }
  return setUser;
}

type UserProviderProps = {
  initialUser?: IUser | null;
  children: React.ReactNode;
};

export function UserProvider({ initialUser = null, children }: UserProviderProps) {
  const [user, setUser] = useState<IUser | null>(initialUser);
  const updateUser = useMemo(() => setUser, []);

  return (
    <UserContext.Provider value={user}>
      <UserUpdateContext.Provider value={updateUser}>
        {children}
      </UserUpdateContext.Provider>
    </UserContext.Provider>
  );
}